import React, { Component } from "react"
import { PORT } from "../../../config"
import axios from "axios"
import { API } from "../../../API"

export default class NavigateToShareProfile extends Component {
  componentDidMount = () => {
    let ids = window.location.search.substring(1).split("tid=")[1]
    ids = decodeURIComponent(ids)
    const tid = ids ? ids.split("&rid=")[0] : null
    const rid = ids ? ids.split("&rid=")[1] : null
    // axios
    //   .get(`${PORT}/user/getSafeData/${tid}`)
    API.getUserSafeDataById(tid)
      .then((res) => {
        let flag;
        if(res.data.user.referees.length > 0){
          flag = res.data?.user?.referees?.filter((ele) => ele._id === rid)[0]
          ?.flag
        }
        
        const path = {
          pathname: "/ReferenceForm",
          state: res.data.user,
          tid: tid,
          rid: rid,
          flag: flag ? flag : false,
        }

        this.props.history.push(path)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  render = () => <div />
}
